var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.sliderStyle)},[_c('div',{attrs:{"id":"GoTop"},on:{"click":function($event){return _vm.GoTop()}}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"topbtn el-carousel__arrow el-carousel__arrow--up",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-top"})])
}]

export { render, staticRenderFns }